import { Route } from '../route.model';
import AddEvent from '@/views/Admin/AddEvent/AddEvent.vue';

const validateRouteFlag = () => {
  return process.env.VUE_APP_ENV === 'development';
};

const adminAddEvent = new Route('/admin/add-event', 'add-event', AddEvent, {
  requiresAuth: true,
  superRoot: true,
  customFlagValidator: validateRouteFlag,
  navbar: {
    name: 'Add Event'
  },
  zendesk: {
    disabled: true
  }
});

export { adminAddEvent };
export default adminAddEvent;
